import Templater from '../templater/Templater';
import { setVariantCommands } from './CommonToAllApps';
import ExternalApp, { IExternalApp } from './ExternalApp';

setVariantCommands();

export type TAuthApp = IExternalApp;
const LoginComponent = Templater.getTemplateByName('Auth');

const AuthApp = (props: TAuthApp) => {
  return <ExternalApp {...props}>{LoginComponent}</ExternalApp>;
};

export default AuthApp;
